import React from 'react'
import RRuleGenerator from 'react-rrule-generator';
import 'react-rrule-generator/build/styles.css';

export default function RuleGenerator(props) {
    

    return (
        <>
              <div className="sb-rrule-generator">
               <RRuleGenerator
                    onChange={(rrule) => console.log(`${rrule}`)}
                    config={{
                         repeat: ['Monthly', 'Weekly' , 'Daily'],
                         yearly: 'on the',
                         monthly: 'on',
                         end: ['Never', 'On date', 'After'],
                         weekStartsOnSunday: true,
                         hideError: true,
                         hideStart:false,                        

                    }}
               />
               </div>
        </>
    )
}
